import React, { Component } from 'react';
import { Steps, Layout, notification, Select, Button } from 'antd/lib';
import { withApollo, graphql, compose } from 'react-apollo';
import * as Icons from '@ant-design/icons';

import * as actionsExpedientes from '../../../actions/expediente';
import * as actionsContraventores from '../../../actions/contraventores';
import * as actionsMain from '../../../actions/main';

import ProcesoImprimir from '../../procesos/ProcesoImprimir';

import Loading from '../../common/Loading';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import moment from 'moment';

const Option = Select.Option;

import insertActuacion from '../../../graphql/mutations/contravenciones/insertActuacion.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { errorService } from '../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertActuacion, {
    name: 'insertActuacion',
  }),
  graphql(getUsuario)
)
class AgregarActuacion extends Component {
  state = {
    contraventores: [],
    step: 0,
  };

  onCancel = () => {
    this.props.history.goBack();
  };

  handleChange = valor => {
    // console.log('Contraventores elegidos: ', valor);
    this.setState({
      contraventores: valor,
    });
  };

  siguientePaso = () => {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  };

  anteriorPaso = () => {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  generarDatos = () => {
    // console.log('entre a generar datos: ');
    // console.log(this.props);
    // console.log(this.state);

    let datos = {};
    if (this.state.contraventores.length > 1) {
      let personasContraventores = [];
      _.each(this.state.contraventores, idContraventor => {
        let contraventorEncontrado = _.find(this.props.contraventores, function(
          contraventor
        ) {
          // console.log("entre a buscar con....", tipoSello);
          return idContraventor === contraventor._id;
        });

        if (contraventorEncontrado) {
          // console.log('Contraventor ENCONTRADOOOOOOOOOOOO');
          // console.log(contraventorEncontrado);
          let per = contraventorEncontrado.persona;
          if (contraventorEncontrado.direccion_real) {
            //Esto significa que tiene direccion real y vamos a utilizarla.
            per = {
              ...per,
              direccion_calle: contraventorEncontrado.direccion_real.calle,
              direccion_numero: contraventorEncontrado.direccion_real.numero,
              direccion_otro: contraventorEncontrado.direccion_real.observacion,
              localidad: contraventorEncontrado.direccion_real.localidad,
              sancion: contraventorEncontrado.sancion,
              articulos: contraventorEncontrado.sancion.articulos,
            };
          }
          personasContraventores.push(per);
        }
      });
      datos = {
        contraventores: personasContraventores,
        expediente: {
          ...this.props.expediente,
          fechaIngreso: moment(this.props.expediente.fechaIngreso).format(
            'DD/MM/YYYY'
          ),
        },
        usuario: this.props.data.getUsuario,
        organismo: this.props.data.getUsuario.organismo,
        expediente_articulos: this.props.expediente
          ? this.props.expediente.articulos
          : null,
      };
    } else {
      if (this.state.contraventores.length == 1) {
        let contraventor = {};

        let contra = this.state.contraventores[0];
        let contraventorEncontrado = _.find(this.props.contraventores, function(
          contraventor
        ) {
          // console.log("entre a buscar con....", tipoSello);
          // console.log('THIS: ', this);
          return contra === contraventor._id;
        });

        if (contraventorEncontrado) {
          // console.log('Contraventor 2222222222');
          // console.log(contraventorEncontrado);
          contraventor = contraventorEncontrado.persona;
          if (contraventorEncontrado.direccion_real) {
            //Esto significa que tiene direccion real y vamos a utilizarla.

            // console.log('SANCION: ', contraventorEncontrado.sancion);

            contraventor = {
              ...contraventor,
              direccion_calle: contraventorEncontrado.direccion_real.calle,
              direccion_numero: contraventorEncontrado.direccion_real.numero,
              direccion_otro: contraventorEncontrado.direccion_real.observacion,
              localidad: contraventorEncontrado.direccion_real.localidad,
              sancion: contraventorEncontrado.sancion,
              articulos: contraventorEncontrado.sancion
                ? contraventorEncontrado.sancion.articulos
                : null,
            };
          }
        }

        datos = {
          contraventor: contraventor,
          expediente: {
            ...this.props.expediente,
            fechaIngreso: moment(this.props.expediente.fechaIngreso).format(
              'DD/MM/YYYY'
            ),
          },
          usuario: this.props.data.getUsuario,
          organismo: this.props.data.getUsuario.organismo,
          sancion:
            this.state.contraventores &&
            this.state.contraventores.length === 1 &&
            contraventorEncontrado.sancion
              ? contraventorEncontrado.sancion
              : null,
          articulos: contraventorEncontrado.sancion
            ? contraventorEncontrado.sancion.articulos
            : null,
          expediente_articulos: this.props.expediente
            ? this.props.expediente.articulos
            : null,
        };
      } else {
        // CASO DONDE NO HAY NINGUN CONTRAVENTOR AL GENERAR UNA ACTUACION.
        datos = {
          expediente: {
            ...this.props.expediente,
            fechaIngreso: moment(this.props.expediente.fechaIngreso).format(
              'DD/MM/YYYY'
            ),
          },
          usuario: this.props.data.getUsuario,
          organismo: this.props.data.getUsuario.organismo,
          expediente_articulos: this.props.expediente
            ? this.props.expediente.articulos
            : null,
        };
      }
    }

    // console.log('DATOS: ', datos);
    return datos;
  };

  crearOpciones(contraventor) {
    return (
      <Option key={contraventor._id} value={contraventor._id}>
        {contraventor.persona.nombre + ' ' + contraventor.persona.apellido}
      </Option>
    );
  }

  guardarActuacion = (htmlActuacion, idModeloNota) => {
    // console.log('Entro a guardar la actuacion...');
    // console.log(idModeloNota)
    // console.log(htmlActuacion);

    this.props
      .insertActuacion({
        variables: {
          objActuacion: {
            tipo: 'BORRADOR',
            idExpediente: this.props.expediente._id,
            textoNota: htmlActuacion,
            idModeloNota: idModeloNota,
          },
        },
      })
      .then(res => {
        // console.log('LA RESPUESTA DE INSERTAR ACTUACION ES: ', res);

        if (res.data.insertActuacion) {
          this.props.actionsExpedientes.agregarActuacion(
            res.data.insertActuacion
          );

          notification.success({
            message: 'Documento agregado correctamente',
            description:
              'El documento se registró correctamente en la base de datos',
          });

          this.props.history.goBack();
        }
      })
      .catch(err => {
        console.log('ERROR EN INSERTAR ACTUACION: ', err);
        errorService(err, {
          objActuacion: {
            tipo: 'BORRADOR',
            idExpediente: this.props.expediente._id,
            textoNota: htmlActuacion,
            idModeloNota: idModeloNota,
          },
        });
        notification.error({
          message: 'Error al agregar el documento',
          description: 'Se ha producido un error al agregar el documento',
        });
      });
  };

  render() {
    const { Step } = Steps;
    let { step } = this.state;

    if (this.state.loading) {
      return <Loading />;
    }

    if (!this.props.expediente._id) {
      // console.log('Ruta prohibida!');
      // console.log(this.props);
      this.props.history.push('/contravenciones/expedientes');
    }

    // console.log('ENTRE:!');
    let opciones = [];
    if (this.props.contraventores) {
      // console.log('los contraventores son...');
      // console.log(this.props.contraventores);
      opciones = _.map(this.props.contraventores, this.crearOpciones);
    } else {
      return <Loading />;
    }
    return (
      <div>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Sumar Contraventor
          </h2>
          <br />
          <Steps size="small" className="stepsFormularios" current={step}>
            <Step title="Seleccionar Contraventores" />
            <Step title="Generar Actuacion" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <div style={{ textAlign: 'center' }}>
                <h3>Seleccionar Contraventores:</h3>
                <Select
                  mode="multiple"
                  style={{ width: '70%' }}
                  placeholder="Elegir Contraventores"
                  onChange={this.handleChange}
                >
                  {opciones}
                </Select>
                <Button
                  type="primary"
                  style={{ float: 'rigth', marginTop: 5, marginLeft: 20 }}
                  onClick={() => this.siguientePaso()}
                >
                  {' '}
                  Siguiente{' '}
                </Button>
              </div>
            )}
            {step === 1 && (
              <ProcesoImprimir
                datos={this.generarDatos()}
                onImprimir={(htmlActuacion, idModeloNota) =>
                  this.setState({ loading: true }, () =>
                    this.guardarActuacion(htmlActuacion, idModeloNota)
                  )
                }
                onGuardar={(htmlActuacion, idModeloNota) =>
                  this.setState({ loading: true }, () =>
                    this.guardarActuacion(htmlActuacion, idModeloNota)
                  )
                }
                onCancel={this.onCancel}
                loading={this.state.loading}
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsExpedientes: bindActionCreators(actionsExpedientes, dispatch),
  actionsContraventores: bindActionCreators(actionsContraventores, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  // console.log('mapStateToPorps: ', state);
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(AgregarActuacion));
